<form #form="ngForm">
  <input
    type="text"
    mdbInput
    class="form-control mb-4"
    placeholder="Enter book title "
    aria-describedby="title"
    name="title"
  />
  <!-- Book  Description -->
  <input
    type="text"
    mdbInput
    class="form-control mb-4"
    placeholder="Enter book Description "
    aria-describedby="Description"
  />

  <!-- Phone number -->
  <input
    type="text"
    mdbInput
    class="form-control mb-4"
    placeholder="Enter book Image "
    aria-describedby="Image"
  />

  <!-- Phone number -->
  <input
    type="number"
    mdbInput
    id="rate"
    class="form-control mb-4"
    placeholder="Enter book rate "
    aria-describedby="rate"
  />
</form>
